<ng-container *ngIf="!is404Page else notfound">
  <div class="wrapper">
    <div #gamewindow class="game-launcher">
      <div class="header">
        <div class="title">
          <a [routerLink]="[backUrl]" class="go-back">
            <img src="{{licenceService.getKey('icon-right')}}" alt="arrow" icon-btn direction="left">
            <span i18n>All Games</span>
          </a>
          <h1>{{gameItem?.name}}</h1>
          <div *ngIf="isBonusExcludedGame"  class="bonus_exclude_tag"><img src="{{licenceService.getKey('bonus-excluded')}}" alt="bonusExclude"><span i18n>BONUS<br/>EXCLUDED</span></div>
        </div>

        <div class="actions" style="display: flex; align-items: center;">
          <app-tournamnent-ingame-info *ngIf="isLoggedIn" [gameIdValue]="gameId"></app-tournamnent-ingame-info>
          <app-missions-ingame-info *ngIf="isLoggedIn" [gameIdValue]="gameId"></app-missions-ingame-info>
          <app-game-favourites-toggle [gameId]="gameId"></app-game-favourites-toggle>
          <div style="flex-grow: 1;"></div> <!-- Flex grow spacer -->
          <div class="close-button-container">
            <a [routerLink]="[backUrl]">
              <app-close-dialog-button [customClass]="'large'" [position]="true"></app-close-dialog-button>
            </a>
          </div>
        </div>
      </div>
      <div class="iframe-container">
        <ng-container [ngSwitch]="provider">
          <app-green-jade [src]="safeUrl" *ngSwitchCase="GREEN_JADE_ARCADE_PRIVIDER"></app-green-jade>
          <ng-container *ngSwitchDefault="">
            <iframe *ngIf="safeUrl" class="game-iframe" allow="autoplay" scrolling="no" frameborder="no" [src]='safeUrl' width="100%" height="100%" frameborder="0" allowfullscreen></iframe>
          </ng-container>
        </ng-container>
      </div>

      <div id="target" class="game-panel" [style.height]="height">
        <img [src]="gameItem?.thumbnailDesktopRectangular?.url" alt="{{gameItem?.name}}" />
        <div class="content">
          <h2 class="name" i18n>About the {{gameItem?.name}} game</h2>
          <div class="description" [innerHTML]="gameItem?.shortDescription?.safe"></div>
        </div>
      </div>

      <div class="toggle">
        <a (click)="toggleData()">
          <span>{{ isReadMore ? showMoreTrx: showLessTrx }}</span>
          <img [class]="isReadMore ? '' : 'rotated'" icon-btn src="{{licenceService.getKey('icon-right')}}" alt="arrow"/>
        </a>
      </div>
    </div>

    <div class="recently-played" *ngIf="logged">
      <div class="header">
        <div class="title" i18n>recently played games</div>
        <div class="nav">
          <div i18n style="padding-right: 6px">See more</div>
          <a (click)="prev()" class="prev">
            <img src="{{licenceService.getKey('icon-right')}}" alt="arrow" icon-btn />
          </a>
          <a (click)="next()" class="next">
            <img src="{{licenceService.getKey('icon-right')}}" alt="arrow" icon-btn />
          </a>
        </div>
      </div>

      <div fxLayout="row" fxLayoutAlign="center start" fxLayoutGap="17px">
        <swiper style="width: 100%;" [config]="config" #swiper>
          <ng-template swiperSlide *ngFor="let game of games">
            <app-tournament-games (onGameSelect)="onGameSelect($event)" [game]="game"></app-tournament-games>
          </ng-template>
        </swiper>
      </div>
    </div>
    <router-outlet></router-outlet>
  </div>
</ng-container>
<ng-template #notfound>
  <app-desktop-not-found-page></app-desktop-not-found-page>
</ng-template>